<template>
  <section>
    <div
      class="loading clearfix"
      v-show="state==1"
    >
      <p class="clearfix">
        <em></em>
        <span>正在加载...</span>
      </p>
    </div>
    <p
      class="no-data"
      v-show="state==2"
    >已无更多数据</p>
  </section>
</template>
<script>
export default {
  name: 'PullLoad',
  props: {
    state: {
      default: 0, // -1 无更多数据  //0 未加载或者加载完成 //1 正在加载中 ,2 无需再次加载提示
      type: Number
    },
    bottomMethod: {
      type: Function
    },
    targetElement: {
      type: String
    }
  },
  data () {
    return {
      element: null,
      loadState: false
    };
  },
  computed: {
    currentState: function () {
      if (this.state === 1 && this.loadState) {
        return true;
      }
    }
  },
  methods: {
    init: function () {
      if (typeof (this.targetElement) === 'object') {
        this.element = this.targetElement;
      } else {
        this.element = document.getElementById(this.targetElement);
      }
      document.addEventListener('scroll', this.scrollHandler);
    },
    scrollHandler: function (event) {
      if (this.state !== 0) {
        return false;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if ((document.body.scrollHeight - window.screen.availHeight - scrollTop) < 5) {
        this.loadState = true;
        this.bottomMethod();
      }
    }
  },
  mounted: function () {
    this.init();
  },
  beforeDestroy: function () {
    console.log('scorll');
    document.removeEventListener('scorll', this.scrollHandler);
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pull-load.vue